module.exports = __webpack_public_path__ + "img/galery-kx5200-2-zoom.460752f5.png";